<template> 
	<div :class="classOption">
		<slot name="firstButton">firstButton</slot>
        <slot name="secondButton">SecondButton</slot>
		<slot name="thirdButton" v-if="buttonNumber > 2 && thirdButtonActive">thirdButton</slot>
		<slot name="fourthButton" v-if="buttonNumber > 3 && fourthButtonActive">fourthButton</slot>
		<!-- 
		feel free to add additional button options as required, 
		component specific classes and function calls should be designated in the parent component 
		use third and fourth button active props when you have conditionally rendered extra buttons
		 -->
	</div>
</template>
<script type="text/javascript">
	export default {
    name: 'sliderTemplate',
    props: ['buttonNumber', 'classOption', 'thirdButtonActive', 'fourthButtonActive']
  }
</script>